export default __webpack_public_path__ + "navigation-examples-building-extrusion-thumbnail-960-309acde72117de08dc8ebdc5a6ae8f5a.webp";